import { useCookieState } from "src/shared/cookie/useCookieState";

export const useUsernameCookie = () => {
  return useCookieState<string>("username");
};
